import { render, staticRenderFns } from "./CreateRequestType.vue?vue&type=template&id=453b4c62&scoped=true&"
import script from "./CreateRequestType.vue?vue&type=script&lang=js&"
export * from "./CreateRequestType.vue?vue&type=script&lang=js&"
import style0 from "./CreateRequestType.vue?vue&type=style&index=0&id=453b4c62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453b4c62",
  null
  
)

export default component.exports